import { render, staticRenderFns } from "./TestTelsit.vue?vue&type=template&id=d91c602e&scoped=true"
import script from "./TestTelsit.vue?vue&type=script&lang=js"
export * from "./TestTelsit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d91c602e",
  null
  
)

export default component.exports